module.exports = __webpack_public_path__ + "img/logo-blue.661257c8.svg";